import { useEffect, useState } from 'react';
import { IonContent, IonModal } from '@ionic/react';
import { useInstance } from '../support/ioc/useInstance';
import { useSubscription } from '@autopylot-internal/state';
import { useBreakpoints } from '../support/hooks/useBreakpoints.tsx';
import { AircraftPickerState } from './AircraftPickerState.ts';
import { AircraftCard } from './AircraftCard.tsx';
import { Button } from '../components/button/Button.tsx';
import { AIRCRAFT_STATUS_LABELS } from './labels.ts';
import { PageHeader } from '../components/page/PageHeader.tsx';
import { LabeledCheckbox } from '../components/field/LabeledCheckbox.tsx';

export const AircraftPicker: React.FC = () => {
    const { isAboveBreakpoint } = useBreakpoints();

    const state = useInstance(AircraftPickerState);
    useSubscription(() => state);

    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        // on open, if no fleet, then jump right into adding one
        if (state.isOpen && state.getFleet().length === 0){
            state.addAircraft();
        }
    }, [state.isOpen, state]);

    return (
        <IonModal isOpen={state.isOpen} onDidDismiss={state.hide}>

            <PageHeader title="Mission Drones" backLabel="Done" onBack={state.hide} />

            <IonContent>

                {state.getFleet().map(aircraft => (
                    <AircraftCard
                        key={aircraft.aircraftId}
                        aircraft={aircraft}
                        onClick={() => state.toggleAircraft(aircraft)}
                        selected={state.isAircraftFlying(aircraft)}
                        hideStats
                        showStatus
                        readonly
                    />
                ))}

                {state.hasArchived() &&
                    <div style={{margin: '25px 20px', justifySelf: isAboveBreakpoint('md') ? 'center' : undefined}}>
                        <LabeledCheckbox
                            label={`Show ${AIRCRAFT_STATUS_LABELS['archived']} drones`}
                            value={showAll || !state.hasNonFlyingArchived()}
                            disabled={!state.hasNonFlyingArchived()}
                            onClick={() => setShowAll(v => !v)}
                        />
                    </div>
                }

                {showAll && state.getNonFlyingArchived().map(aircraft => (
                    <AircraftCard
                        key={aircraft.aircraftId}
                        aircraft={aircraft}
                        onClick={() => state.toggleAircraft(aircraft)}
                        selected={state.isAircraftFlying(aircraft)}
                        hideStats
                        showStatus
                        readonly
                    />
                ))}

                <div style={{margin: '25px 20px'}}>
                    <Button expand="block" fill={state.getFleet().length === 0 ? 'solid' : 'outline'} onClick={() => state.addAircraft()}>New Drone</Button>
                </div>

            </IonContent>
        </IonModal>
    );
};
